import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import Routers from "./routes";
import "react-image-crop/dist/ReactCrop.css";
import "./assets/css/feed_style.css";
import "./assets/css/login-page.css";
import "./assets/css/LinkPreviews.css";
import "./assets/css/style.css";
import "./assets/css/light-theme.css";
import "./assets/css/sidebar.css";
import "./assets/css/AppLoader.css";
import "./assets/css/StudentPortalSetting.css";
import "./assets/css/ChooseDocument.css";
import "./assets/css/portal-auth.css";
import "./assets/css/portal-landing.css";
import "@xinosolutions/xs-shell/styles.css";

import { SnackbarProvider } from "notistack";
import { Button, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ContentSettingState } from "./Hooks/ContentSetting";
import ThemeConfig from "./theme";
import { ThemeProvider } from "./contexts/ThemeContext";
import ErrorBoundaryFallback from "./components/ErrorBoundaryFallback";
import AuthProviders from "./components/providers/AuthProviders";
import { useTranslation } from "react-i18next";
import { getTextDirection } from "./i18n";

function NotistackWithDirection({ notistackRef, onClickDismiss, children }) {
  const { i18n } = useTranslation();
  const isRtl =
    getTextDirection(i18n.resolvedLanguage || i18n.language || "en") === "rtl";

  return (
    <SnackbarProvider
      ref={notistackRef}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: isRtl ? "left" : "right",
      }}
      TransitionComponent={Slide}
      maxSnack={3}
      action={(key) => (
        <Button
          className="snackbar-cross-icon"
          onClick={onClickDismiss(key)}
        >
          <CloseIcon />
        </Button>
      )}
    >
      {children}
    </SnackbarProvider>
  );
}

function App() {
  const notistackRef = React.createRef();

  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <div className="App">
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
        <ThemeProvider defaultTheme="dark">
          <ThemeConfig>
            <NotistackWithDirection
              notistackRef={notistackRef}
              onClickDismiss={onClickDismiss}
            >
              <AuthProviders>
                <ContentSettingState>
                  <Routers />
                </ContentSettingState>
              </AuthProviders>
            </NotistackWithDirection>
          </ThemeConfig>
        </ThemeProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
